<template>
  <header class="headerComponent">
    <div class="logoHeaderPrincipal">
      <img src="../../assets/images/logoYoigo.svg" class="img-fluid" alt="yoigo">
    </div>
    <div class="row subHeader" id="header" >
        <span class="baseColor col-6 headerTextIzq">
            LUZ Y GAS
        </span>
        <span class="text-right  headerText roboto700 col-6">Llámanos gratis al <br/><span class="baseColor">900622700</span></span>
    </div>
</header>
</template>

<script>
export default {
  name:'common-header'
}
</script>



// WEBPACK FOOTER //
// src/components/header/header.vue